// @flow

import { getRealDate } from '../../utils/Utils';
import type { TimesheetProjection } from '../../common/typings';

export default function extendTimesheetProjection(_model: Object): TimesheetProjection {
  const model = { ..._model };
  model.clockInLocal = new Date(model.clockIn);
  model.clockIn = getRealDate(model.clockIn);

  model.lastActionLocal = new Date(model.lastAction);
  model.lastAction = getRealDate(model.lastAction);

  if (model.clockOut) {
    model.clockOutLocal = new Date(model.clockOut);
    model.clockOut = getRealDate(model.clockOut);
  }

  return model;
}
